import { IsIn } from 'class-validator';
import { CURRENCY_OPTIONS } from '../data/currency';

export type SupportedCurrency = (typeof CURRENCY_OPTIONS)[number]['code'];

export class CurrencyDto {
  @IsIn(CURRENCY_OPTIONS.map((t) => t.code))
  currency!: SupportedCurrency;
}
